//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import xButton from '../common/x-button.vue'
import ProtocolList from "../instructionProtocol/list"   
import { staticType } from "./config"    

export default {
    components: { xButton, ProtocolList },
    name:'NewProtocol',
    data(){
        return{
            treatyList:[{flag:'notice',name:'投保须知'},{flag:'agreement',name:'保险条款'},{flag:'protocol',name:'服务协议'}],
            modeShow:false
        }
    },
    props:{
        templateFlag:{ 
            type: String,
            default() { return '' }
        },
        staticName:{ //埋点配置信息
            type: String,
            default() { return 'proinfo' } 
        },
        protocolInfo:{
            type:Object,
            default() { return {
                productName:'',
                buyerName:'',
                insuredName:''
            }}
        }
    },
    mounted(){
        // 弹窗弹出埋点
        staticType[this.staticName].showBox()
    },
    methods:{
        // 展示弹框
        treatyClick(item){
            staticType[this.staticName].treatyshow()
            this.$refs.protocolList.show(item)
        },
        btnClick(){
            staticType[this.staticName].check()
            staticType[this.staticName].close()
            this.modeShow=false
            this.$emit('submitClick', true)
        },
        // 关闭弹窗
        input(){
            staticType[this.staticName].close()
            this.modeShow=false
        }
    }
}
